export default __webpack_public_path__ + "static/media/shushing-face.46943a60.png";